import { useEffect, useState } from "react";
import styled from "styled-components";
import { ImageConfig } from "../../models/client";
import { Box } from "../Box";
import { FlexContainer, FlexItem } from "../Flex";

type LabelPosition = "t" | "b";

interface TimelineImageProps {
  imageConfig: ImageConfig;
  labelPosition?: LabelPosition;
}

const Wrapper = styled(FlexContainer)`
  img {
    width: 100%;
    height: auto;
    vertical-align: middle;
  }
`;

export const TimelineImage: React.FC<TimelineImageProps> = ({
  imageConfig,
  labelPosition,
  children,
}) => {
  const [isPng, setIsPng] = useState(false);

  useEffect(() => {
    setIsPng(imageConfig.src.split(".")[1].includes("png"));
  }, [setIsPng, imageConfig]);

  return (
    <Wrapper
      flexDirection={labelPosition === "t" ? "column-reverse" : "column"}
    >
      <FlexItem>
        <Box
          boxShadow={!isPng ? 1 : null}
          style={
            isPng
              ? { filter: "drop-shadow(0px 30px 60px rgba(50, 50, 93, 0.25))" }
              : {}
          }
        >
          <img
            src={imageConfig.src}
            alt={imageConfig.title}
            width={imageConfig.width}
            height={imageConfig.height}
          />
        </Box>
      </FlexItem>
      <FlexItem py={[2, null, null, 2]}>{children}</FlexItem>
    </Wrapper>
  );
};
